import { useTranslation } from "react-i18next";
import { TextInput } from "@mantine/core";

import { useClientSettingsFormContext } from "./formContext";

export { ClientSettingsFormProvider, parseClientSettingsInput, useClientSettingsForm } from "./formContext";

export const ClientSettingsForm = () => {
    const { t } = useTranslation(["common"]);

    const clientSettingsForm = useClientSettingsFormContext();

    return (
        <>
            <TextInput
                {...clientSettingsForm.getInputProps("name")}
                label={t("client_name")}
                placeholder={t("client_name")}
            />
        </>
    );
};
